import http from '../../utils/http';
import { getApiBaseUrl } from '@/utils/env'

//检索示例
export const GetRandonList = () => {
  return http.get(`/api/CaseSearchPreset/GetRandomList`);
};

//问题润色
export const PolishQuestion = (data) => {
  return http.post('/api/QuestionPolish/PolishQuestion', data);
};

//查询法院
export const GetTree = (data) => {
  return http.get('/api/Court/GetTree', data);
};

//类案检索
export const HybridSearch = (data) => {
  return http.post('/api/DocumentSearch/HybridSearch', data);
};

//类案检索收藏
export const BatchAdd = (data) => {
  return http.post('/api/CaseFavorite/BatchAdd', data);
};

//类案检索收藏2
export const BatchAddByArray = (data) => {
  return http.post('/api/CaseFavorite/BatchAddByArray', data);
};


//类案检索查看详情
export const AnalyzeCase = (data) => {
  return http.post('/api/DocumentSearch/AnalyzeCase', data);
};

//类案检索查看详情
export const Export = (data) => {
  return http.post('/api/ReportExport/Export', data);
};

// 上传并提取文件内容
export const UploadAndExtract = (formData) => {
  return http.post('/api/DocumentSearch/UploadAndExtract/UploadAndExtract', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 批量下载案例（返回文件流）
export const BatchDownloadCases = (data) => {
  return http.post('/api/DocumentSearch/BatchDownloadCases/BatchDownloadCases', data, {
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'blob'
  });
};

const apiBaseUrl = getApiBaseUrl() || ''

// 起诉文书 AI 对话启动（SSE 流式）
export const StartConversation = (data) => {
  const token = localStorage.getItem('token')
  return fetch(`${apiBaseUrl}api/IndictmentConversation/Start`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify(data)
  })
}

// 起诉文书 AI 继续对话（SSE 流式），需传 sessionId
export const ContinueConversation = (sessionId, data) => {
  const token = localStorage.getItem('token')
  return fetch(`${apiBaseUrl}api/IndictmentConversation/Continue`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify({
      sessionId,
      ...data
    })
  })
}

// 起诉文书保存（上传文件到会话）
export const SaveIndictmentConversation = (sessionId, file) => {
  const formData = new FormData()
  formData.append('file', file)
  return http.post(`/api/IndictmentConversation/Save?sessionId=${sessionId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 按案号查询案例详情
export const SearchByCaseNumber = (caseNumber) => {
  return http.post(`/api/DocumentSearch/SearchByCaseNumber?caseNumber=${encodeURIComponent(caseNumber)}`);
}

// 按案号取消收藏
export const RemoveByCaseNumber = (caseNumber) => {
  return http.post(`/api/CaseFavorite/RemoveByCaseNumber?caseNumber=${encodeURIComponent(caseNumber)}`);
};

// 生成追问问题
export const GenerateFollowUpQuestions = (query) => {
  return http.post('/api/CaseFollowUp/GenerateFollowUpQuestions', { query });
};
